module.exports = __webpack_public_path__ + "img/somos_vision.542ff7fe.jpg";